import { MonthPickerInput } from "@mantine/dates";
import classes from "../../input/input.module.css";
export const monthPickerInputProps = MonthPickerInput.extend({
    classNames: classes,
});
